import Product from '../requestType/product/product';
import RichContent from '../requestType/richContent/richContent';
import parseQueryString from '../util/parseQueryString';

export default function Content() {

		let query
		let urlParameters
		let requestType


		if (typeof window !== "undefined") {
			query = window.location.search.substring(1);
			urlParameters = parseQueryString(query)
		}

		//requestType = urlParameters && urlParameters.requestType
		requestType = urlParameters && urlParameters.requestType ? urlParameters.requestType : null
		let productId = urlParameters && urlParameters.productId ? urlParameters.productId  : null
		let richId = urlParameters && urlParameters.richId ? urlParameters.richId : null
		let campaignId = urlParameters && urlParameters.campaignId ? urlParameters.campaignId  : null
		let retailer = urlParameters && urlParameters.retailer  ? urlParameters : 'walmart'
		let website = urlParameters && urlParameters.website  ? urlParameters : 'walmart'
		let medium = urlParameters && urlParameters.medium  ? urlParameters : 'ec'
		let source = urlParameters && urlParameters.source  ? urlParameters : 'walmart'

		if (typeof window !== "undefined") {

				let referrerUrl = window.document.referrer ? window.document.referrer : ''

				if (referrerUrl.includes('grocery.walmart')){
					website = 'walmartGrocery'
					source = 'walmartGrocery'
				}

				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					"event" : "cc.pageView",
					requestType,
					productId,
					richId,
					campaignId,
					retailer,
					website,
					medium,
					source
				})
		} else {
				//window.not available
				//console.log('window na')
		}


		if (!requestType){
			return null
		}

		if ( requestType === 'product'){
			return (
				<div  className='col-xs-12'>
					<Product urlParameters={urlParameters} website={website} />
				</div>
			);
		}	else if ( requestType === 'richContent') {
			return(
				<div className='col-xs-12'>
					<RichContent urlParameters={urlParameters} website={website} />
				</div>
			)
		}

		return null


}



// WEBPACK FOOTER //
// ./components/content/content.js